import React from 'react'
import logo from '../assets/logo.png'; 

function Header(props) {
  return (
    <div className='header'>
        <img className='logo' src={logo} alt="logo" />
        <h3>Remember</h3>
    </div>
  )
}

export default Header;